/// <reference path="./globals.d.ts" />
/**
 * Configures the marked.js Markdown parser with highlight.js syntax highlighting
 * and registers a global `copyCode` helper used by rendered code block buttons.
 */
export function initMarkdown(): void {
    marked.use({
        breaks: true,
        gfm: true,
        renderer: {
            link(this, { href, title, tokens }: any): string {
                const self = this as any;
                const text = self.parser.parseInline(tokens);
                const titleAttr = title ? ` title="${title}"` : '';
                const isExternal = /^https?:\/\//.test(href);
                const target = isExternal ? ' target="_blank" rel="noopener noreferrer"' : '';
                return `<a href="${href}"${titleAttr}${target}>${text}</a>`;
            },
            code(codeText: string, infoString?: string): string {
                const lang = (infoString || '').match(/\S*/)?.[0] || '';
                let highlightedCode: string;
                try {
                    if (lang && hljs.getLanguage(lang)) {
                        highlightedCode = hljs.highlight(codeText, { language: lang }).value;
                    } else {
                        highlightedCode = hljs.highlightAuto(codeText).value;
                    }
                } catch (e) {
                    highlightedCode = codeText;
                }
                return `<pre><code class="hljs ${lang}">${highlightedCode}</code><button class="copy-btn" title="Copy code" onclick="copyCode(this)"><i class="fa-regular fa-copy"></i></button></pre>`;
            }
        }
    });

    // Expose globally so inline onclick handlers in rendered HTML can call it
    (window as any).copyCode = function (button: HTMLButtonElement) {
        const codeElement = button.previousElementSibling as HTMLElement;
        if (!codeElement) return;
        const textToCopy = codeElement.innerText;

        navigator.clipboard.writeText(textToCopy).then(() => {
            const icon = button.querySelector('i');
            if (!icon) return;
            button.style.borderColor = 'var(--success)';
            icon.className = 'fa-solid fa-check';
            icon.style.color = 'var(--success)';

            setTimeout(() => {
                button.style.borderColor = '';
                icon.className = 'fa-regular fa-copy';
                icon.style.color = '';
            }, 2000);
        }).catch(err => {
            console.error('Could not copy code block: ', err);
        });
    };
}
